import { render } from "./EmailResetPassword.vue?vue&type=template&id=728ff581"
import script from "./EmailResetPassword.vue?vue&type=script&lang=js"
export * from "./EmailResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tavakolinejad-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__